// src/theme/components/stack.js
// Stack (VStack, HStack) components için mobil optimize spacing

const Stack = {
  baseStyle: {
    // Mobil için daha kompakt default spacing
    spacing: { base: 2, md: 3 },  // 8px mobil, 12px desktop
  },
  variants: {
    compact: {
      spacing: { base: 1.5, md: 2 },  // 6px mobil, 8px desktop
    },
    comfortable: {
      spacing: { base: 3, md: 4 },  // 12px mobil, 16px desktop
    },
    spacious: {
      spacing: { base: 4, md: 6 },  // 16px mobil, 24px desktop
    },
  },
  defaultProps: {
    spacing: { base: 2, md: 3 },
  },
};

export default Stack;
